import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { FourzerofourComponent } from './fourzerofour/fourzerofour.component';
import { OldPanelComponent } from './admin/old-panel/old-panel.component';
import { ForbiddenComponent } from './forbidden/forbidden.component';
import {
  isAuthCallbackUrl,
  peekAuthReturnUrl,
} from './shared/services/token.util';
import { coordinatorPanelRoleGuard } from './shared/services/coordinator-panel-role.guard';
// import { SchoolClientModule } from './school-client/school-client.module';

const routes: Routes = [
  {
    path: 'forbidden',
    component: ForbiddenComponent,
  },
  {
    path: 'admin',
    data: { module: 'admin' },
    loadChildren: () =>
      import(`./admin/admin.module`).then((m) => m.AdminModule),
  },
  {
    path: 'client',
    data: { module: 'client' },
    loadChildren: () =>
      import(`./client/client.module`).then((m) => m.ClientModule),
  },
  {
    path: 'coordinator',
    data: { module: 'coordinator', panelRole: 'Coordinator' },
    canActivate: [coordinatorPanelRoleGuard],
    loadChildren: () =>
      import(`./coordinator/coordinator.module`).then(
        (m) => m.CoordinatorModule
      ),
  },
  {
    path: 'evaluator',
    data: { module: 'evaluator', panelRole: 'Evaluator' },
    canActivate: [coordinatorPanelRoleGuard],
    loadChildren: () =>
      import(`./coordinator/coordinator.module`).then(
        (m) => m.CoordinatorModule
      ),
  },
  {
    path: 'super-admin',
    data: { module: 'super-admin' },
    loadChildren: () =>
      import(`./admin/admin.module`).then((m) => m.AdminModule),
  },
  {
    path: 'consultant',
    data: { module: 'consultant' },
    loadChildren: () =>
      import(`./client/client.module`).then((m) => m.ClientModule),
  },
  { path: 'fourzerofour', component: FourzerofourComponent },
  { path: 'oldpanel', component: OldPanelComponent },
  // { path: '**', redirectTo: '/fourzerofour', pathMatch: 'full' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: false,
      enableTracing: false,
      preloadingStrategy: PreloadAllModules,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
